import { Form, useForm } from '@/components/forms';
import Input from '@/components/forms/Input';
import { useDynamicLocale } from '@/hoslog-intl';
import { StaticDataTypeDetail } from '@/services/staticDataType/staticDataType.types';
import { z } from 'zod';
import { useCreateStaticDataType, useUpdateStaticDataType } from './hooks/useStaticDataTypeMutations';

const schema = z.object({
  staticDataTypeName: z.string().min(1, { message: 'common.form.validation.required' }),
  staticDataTypeDescription: z.string().min(1, { message: 'common.form.validation.required' }),
});

export const ManageStaticDataTypeView = ({
  staticDataTypeId,
  staticData,
}: {
  staticDataTypeId?: string;
  staticData?: StaticDataTypeDetail;
}) => {
  const form = useForm({
    schema,
    mode: 'onBlur',
    defaultValues: {
      staticDataTypeName: staticData?.staticDataTypeName ?? '',
      staticDataTypeDescription: staticData?.staticDataTypeDescription ?? '',
    },
  });
  const { t } = useDynamicLocale();
  const { mutateAsync: createStaticData } = useCreateStaticDataType();
  const { mutateAsync: updateStaticData } = useUpdateStaticDataType();
  return (
    <Form
      form={form}
      onSubmit={async (data) => {
        if (staticDataTypeId) {
          await updateStaticData({
            staticDataTypeId: staticDataTypeId,
            ...data,
          });
        } else await createStaticData(data);
      }}
    >
      <div className="w-full flex flex-col gap-4.5">
        <Input
          label="logsManagement.staticDataType.manageStaticDataType.label.staticDataTypeName"
          maxLength={50}
          placeholder={t('logsManagement.staticDataType.manageStaticDataType.placeholder.staticDataTypeName')}
          {...form.register('staticDataTypeName')}
        />
        <Input
          label="logsManagement.staticDataType.manageStaticDataType.label.staticDataDescription"
          maxLength={50}
          placeholder={t('logsManagement.staticDataType.manageStaticDataType.placeholder.staticDataDescription')}
          {...form.register('staticDataTypeDescription')}
        />
      </div>
    </Form>
  );
};
